export default __webpack_public_path__ + "static/media/Group 3379@2x.d35104f4.png";